import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
      { path: '/', component: () => import('@/views/home/HomePage.vue') },
      { path: 'tool', component: () => import('@/views/home/ToolsView.vue') },
      { path: 'tool/json', component: () => import('@/views/home/JsonToolView.vue') },
      { path: 'tool/salary', component: () => import('@/views/home/SalaryToolView.vue') },
      { path: 'tool/password', component: () => import('@/views/home/PasswordToolView.vue') },
      { path: 'tool/qr', component: () => import('@/views/home/QrToolView.vue') },
      { path: 'tool/video-watermark', component: () => import('@/views/home/VideoWatermarkToolView.vue') },
      { path: 'tool/markdown', component: () => import('@/views/home/MarkdownToolView.vue') },
      { path: 'tool/markdown/:id', component: () => import('@/views/home/MarkdownToolView.vue') },
      { path: 'messages', component: () => import('@/views/home/messages.vue') },
      { path: 'about', component: () => import('@/views/home/AboutView.vue') },
      { path: 'blog/:id', component: () => import('@/views/home/BlogDetail.vue') },
      { path: 'types', component: () => import('@/views/home/TypesPage.vue') },
      { path: 'tags', component: () => import('@/views/home/TagsPage.vue') },
      { path: 'archives', component: () => import('@/views/home/ArchivesPage.vue') },
      { path: 'search', component: () => import('@/views/home/SearchPage.vue') },
    ]
  },
  { path: '/404', component: () => import('@/views/404.vue') },
  { path: '/500', component: () => import('@/views/500.vue') },
  { path: '/502', component: () => import('@/views/502.vue') },
  { path: '/*', component: () => import('@/views/404.vue') }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
